var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.402,
    height: 16.402,
    viewBox: "0 0 16.402 16.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-text",
    "data-name": "Icon open-text",
    d: "M0,0V3.851H.963A1.931,1.931,0,0,1,2.888,1.925H5.776V12.514a.953.953,0,0,1-.963.963H3.851V15.4h7.7V13.477h-.963a.953.953,0,0,1-.963-.963V1.925h2.888A1.931,1.931,0,0,1,14.44,3.851H15.4V0Z",
    transform: "translate(0.5 0.5)",
    fill: "#7119bf",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextTool);
export default __webpack_public_path__ + "static/media/text_tool.d8b6156fb18490e4c7720d4c0f91b8eb.svg";
export { ForwardRef as ReactComponent };